import { render, staticRenderFns } from "./activityStatusForm.vue?vue&type=template&id=2d205db3"
import script from "./activityStatusForm.vue?vue&type=script&lang=js"
export * from "./activityStatusForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports